import { ThemeColor } from '@vsolv/vectors-ui/theming';
import { Model } from '../model';
import { Model as ItemModel } from './model';
import { Status } from './status';

export function included(claim: Model, coverageId: string) {
  return (
    claim.warranty?.coverages?.some(
      coverage => coverage.coverageId === coverageId && coverage.requirement !== 'NOT_APPLICABLE'
    ) ?? false
  );
}

export function getTheme(status: Status): ThemeColor {
  switch (status) {
    case Status.APPROVED:
    case Status.RESOLVED:
      return 'success';
    case Status.REJECTED:
      return 'danger';
    default:
      return 'default';
  }
}

/** Whether the job has active charges, read from the claim's totals snapshot. */
export function hasCharges(claim: Model | null | undefined, itemId: string) {
  const job = claim?.totals?.source?.jobs.find(job => job.id === itemId);
  return !!job && !job.deleted && job.charges.some(charge => !charge.deleted);
}

/** Jobs with charges are decided on their charges; older jobs still need a cure first. */
export function readyForAdjudication(claim: Model | null | undefined, item: Pick<ItemModel, 'id' | 'cure'>) {
  return !!item.cure?.title || hasCharges(claim, item.id);
}
